import React, { useState, useEffect, useRef, Fragment } from "react";
import { Form, FormGroup, Input, Button, Row, Col } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";
import { NumberFormatInput } from "../../../NumberFormatInput/NumberFormatInput";
import { KYCStatus, KYCReason } from "../types";
import { CustomFormInput, SelectFormField, FormField } from "../../../../utils/FormFields";
import { CircularProgress } from "../../../..";
import { AccountMode, PersonMode, showToast } from "../../../../utils/Helper";
import { parseDate } from "./../../../../utils/dateUtils";

const KYCTab = ({ KYC, person, setPersonData, services, onboarding, mode, role, refresh }) => {
  const [loadingSave, setLoadingSave] = useState(false);
  const [changedKYC, setChangedKYC] = useState({});

  const [initialstatus, setInitial] = useState("New");

  const handleSave = () => {
    const sendKYC = { ...KYC, ...changedKYC };

    const postPerson = {
      ...person,
      KYC: sendKYC,
    };
    const body = {
      OnboardingId: onboarding,
      postPerson: postPerson,
    };

    setLoadingSave(true);
    if (mode === PersonMode.New) {
      services.fetchNewPerson(body, (res) => {
        if (res) {
          setPersonData({
            ...postPerson,
          });
          setChangedKYC({});
          setLoadingSave(false);
          showToast("Changes saved successfully");
          refresh();
        } else {
          setLoadingSave(false);
        }
      });
    } else {
      services.fetchPersonKYC({ person: postPerson }, ({ result }) => {
        if (result && result.Code === 200) {
          setPersonData(
            {
              ...person,
              KYC: changedKYC,
            },
            true
          );
          setChangedKYC({});
          setLoadingSave(false);
          refresh();
        } else {
          setLoadingSave(false);
        }
      });
    }
  };

  const onChange = (name, value) => {
    if (!loadingSave) {
      const newKYC = { ...changedKYC };
      if (KYC[name] !== value) {
        newKYC[name] = value;
      } else if (newKYC[name]) {
        newKYC[name] = undefined;
      }
      setChangedKYC(newKYC);
    }
  };

  const revert = () => setChangedKYC({});

  if (!KYC) {
    return <CircularProgress sm />;
  }

  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          <Row>
            <Col>
              <CustomFormInput label="Person Name">
                <Input
                  disabled={true}
                  value={
                    changedKYC.KYCPersonName || changedKYC.KYCPersonName === ""
                      ? changedKYC.KYCPersonName
                      : KYC.KYCPersonName
                  }
                  onChange={(e) => onChange("KYCPersonName", e.target.value)}
                />
              </CustomFormInput>
            </Col>
            <Col>
              <CustomFormInput label="Person Document Number ">
                <Input
                  disabled={true}
                  value={
                    changedKYC.KYCPersonDocumentNumber || changedKYC.KYCPersonDocumentNumber === ""
                      ? changedKYC.KYCPersonDocumentNumber
                      : KYC.KYCPersonDocumentNumber
                  }
                  onChange={(e) => onChange("KYCPersonDocumentNumber", e.target.value)}
                />
              </CustomFormInput>
            </Col>
            <Col>
              <SelectFormField
                disabled={true}
                label="Person is PEP: "
                value={changedKYC.KYCPersonIsPEP || KYC.KYCPersonIsPEP}
                name="KYCPersonIsPEP"
                onChange={onChange}
                selectItems={[true, false]}
                getSelectItemId={(i) => i}
                getSelectItemName={(i) => (i ? "Yes" : "No")}
              />
            </Col>
          </Row>
          <Row></Row>
          <Row>
            <Col>
              <CustomFormInput label="Person Nationality ">
                <Input
                  disabled={true}
                  value={
                    changedKYC.KYCPersonNationality || changedKYC.KYCPersonNationality === ""
                      ? changedKYC.KYCPersonNationality
                      : KYC.KYCPersonNationality
                  }
                  onChange={(e) => onChange("KYCPersonNationality", e.target.value)}
                />
              </CustomFormInput>
            </Col>
            <Col>
              <CustomFormInput label="Person Type ">
                <Input
                  disabled={true}
                  value={
                    changedKYC.KYCPersonType || changedKYC.KYCPersonType === ""
                      ? changedKYC.KYCPersonType
                      : KYC.KYCPersonType
                  }
                  onChange={(e) => onChange("KYCPersonType", e.target.value)}
                />
              </CustomFormInput>
            </Col>
          </Row>
          <Row>
            <Col>
              <CustomFormInput label="Person Age">
                <NumberFormatInput
                  disabled={true}
                  type="text"
                  customInput={Input}
                  value={
                    changedKYC.KYCPersonAge || changedKYC.KYCPersonAge === ""
                      ? changedKYC.KYCPersonAge
                      : KYC.KYCPersonAge
                  }
                  onValueChange={(e) => onChange("KYCPersonAge", e.value)}
                  dataTypeDecimalName="default"
                />
              </CustomFormInput>
            </Col>
            <Col>
              <CustomFormInput label="Person Activity">
                <Input
                  disabled={true}
                  type="text"
                  value={
                    changedKYC.KYCPersonActivity || changedKYC.KYCPersonActivity === ""
                      ? changedKYC.KYCPersonActivity
                      : KYC.KYCPersonActivity
                  }
                  onChange={(e) => onChange("KYCPersonActivity", e.target.value)}
                />
              </CustomFormInput>
            </Col>
            <Col>
              <CustomFormInput label="Person Address ">
                <Input
                  disabled={true}
                  type="text"
                  value={
                    changedKYC.KYCPersonAddress || changedKYC.KYCPersonAddress === ""
                      ? changedKYC.KYCPersonAddress
                      : KYC.KYCPersonAddress
                  }
                  onChange={(e) => onChange("KYCPersonAddress", e.target.value)}
                />
              </CustomFormInput>
            </Col>
          </Row>
          <Row>
            <Col>
              <CustomFormInput label="Person Risk ">
                <Input
                  disabled={true}
                  type="text"
                  value={
                    changedKYC.KYCPersonRisk || changedKYC.KYCPersonRisk === ""
                      ? changedKYC.KYCPersonRisk
                      : KYC.KYCPersonRisk
                  }
                  onChange={(e) => onChange("KYCPersonRisk", e.target.value)}
                />
              </CustomFormInput>
            </Col>
            <Col>
              <CustomFormInput label="Person Transactional Limit ">
                <NumberFormatInput
                  disabled={true}
                  type="text"
                  customInput={Input}
                  value={KYC.KYCPersonTransactionalLimit}
                  onValueChange={(e) => onChange("KYCPersonTransactionalLimit", e.value)}
                  dataTypeDecimalName="currency"
                />
              </CustomFormInput>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormField
                label="KYC Compliance Date: "
                type="date"
                value={
                  changedKYC.KYCValidatedDate || changedKYC.KYCValidatedDate == ""
                    ? parseDate(changedKYC.KYCValidatedDate)
                    : parseDate(KYC.KYCValidatedDate)
                }
                name="KYCValidatedDate"
                onChange={onChange}
                disabled={role !== "Compliance"}
              />
            </Col>
            <Col>
              <FormField
                label="KYC Advisor Date: "
                type="date"
                value={
                  changedKYC.KYCDate || changedKYC.KYCDate === ""
                    ? parseDate(changedKYC.KYCDate)
                    : parseDate(KYC.KYCDate)
                }
                name="KYCDate"
                onChange={onChange}
                disabled={role !== "Advisor"}
              />
            </Col>
            <Col>
              <FormField
                label="KYC Matured Date: "
                type="date"
                value={
                  changedKYC.KYCMaturedDate || changedKYC.KYCMaturedDate === ""
                    ? parseDate(changedKYC.KYCMaturedDate)
                    : parseDate(KYC.KYCMaturedDate)
                }
                name="KYCMaturedDate"
                onChange={onChange}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <SelectFormField
                label="KYC Reason: "
                value={
                  changedKYC.KYCReason === "" && KYC.KYCReason === ""
                    ? initialstatus
                    : changedKYC.KYCReason
                    ? changedKYC.KYCReason
                    : KYC.KYCReason
                }
                name="KYCReason"
                selectItems={Object.keys(KYCReason)}
                getSelectItemId={(i) => i}
                getSelectItemName={(i) => KYCReason[i]}
                onChange={onChange}
                disabled={role === "BackOffice"}
              />
            </Col>
            <Col>
              <SelectFormField
                label="KYC Status: "
                value={
                  changedKYC.KYCStatus === "" && KYC.KYCStatus === ""
                    ? initialstatus
                    : changedKYC.KYCStatus
                    ? changedKYC.KYCStatus
                    : KYC.KYCStatus
                }
                name="KYCStatus"
                selectItems={Object.keys(KYCStatus)}
                getSelectItemId={(i) => i}
                getSelectItemName={(i) => KYCStatus[i]}
                onChange={onChange}
                disabled={role !== "Compliance"}
              />
            </Col>
          </Row>
          <CustomFormInput label="Comments Advisor: ">
            <Input
              type="textarea"
              value={
                changedKYC.KYCAdvisorComments || changedKYC.KYCAdvisorComments === ""
                  ? changedKYC.KYCAdvisorComments
                  : KYC.KYCAdvisorComments
              }
              onChange={(e) => onChange("KYCAdvisorComments", e.target.value)}
              disabled={role !== "Advisor"}
            />
          </CustomFormInput>

          <CustomFormInput label="Comments Compliance: ">
            <Input
              type="textarea"
              value={
                changedKYC.KYCValidateComments || changedKYC.KYCValidateComments === ""
                  ? changedKYC.KYCValidateComments
                  : KYC.KYCValidateComments
              }
              onChange={(e) => onChange("KYCValidateComments", e.target.value)}
              disabled={role !== "Compliance"}
            />
          </CustomFormInput>

          {onboarding && (
            <div>
              <CustomFormInput label="Status FROM External System: ">
                <Input
                  disabled={true}
                  type="textarea"
                  value={
                    changedKYC.KYCExternalStatus || changedKYC.KYCExternalStatus === ""
                      ? changedKYC.KYCExternalStatus
                      : KYC.KYCExternalStatus
                  }
                  onChange={(e) => onChange("KYCExternalStatus", e.target.value)}
                />
              </CustomFormInput>

              <CustomFormInput label="PLD FROM External System: ">
                <Input
                  disabled={true}
                  type="textarea"
                  value={changedKYC.IsPLD || changedKYC.IsPLD === "" ? changedKYC.IsPLD : KYC.IsPLD}
                  onChange={(e) => onChange("IsPLD", e.target.value)}
                />
              </CustomFormInput>
            </div>
          )}
          <CustomFormInput label="Flags FROM External System: ">
            <Input
              disabled={true}
              type="textarea"
              value={changedKYC.KYCFlags || changedKYC.KYCFlags === "" ? changedKYC.KYCFlags : KYC.KYCFlags}
              onChange={(e) => onChange("KYCFlags", e.target.value)}
            />
          </CustomFormInput>
        </FormGroup>
      </Form>
      {role !== "BackOffice" && (
        <Fragment>
          {mode !== PersonMode.New && (
            <Button style={{ marginRight: 10 }} disabled={loadingSave} onClick={() => revert()}>
              <i className="fa fa-undo" /> Revert
            </Button>
          )}
          <LaddaButton
            className="btn btn-ladda btn-primary"
            loading={loadingSave}
            disabled={Object.keys(changedKYC).length === 0}
            onClick={() => handleSave()}
            data-style={EXPAND_RIGHT}
          >
            Save
          </LaddaButton>
        </Fragment>
      )}
    </div>
  );
};

KYCTab.propTypes = {
  KYC: PropTypes.object,
  setAccountData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  mode: PropTypes.object.isRequired,
};

KYCTab.defaultProps = {
  KYC: undefined,
};

export default KYCTab;
